import { SvgIcon, SvgIconProps } from "@mui/material";
import type { JSX } from "react";

export const HelmetIcon = (props: SvgIconProps): JSX.Element => (
  <SvgIcon viewBox="0 0 30 20" fill="none" {...props}>
    <g clipPath="url(#clip0_13727_5222)">
      <mask
        id="mask0_13727_5222"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="30"
        height="20"
      >
        <path d="M29.387 0H0V19.6933H29.387V0Z" fill="white" />
      </mask>

      <g mask="url(#mask0_13727_5222)">
        <path
          d="M2.02151 16.4391C1.75412 12.6991 3.11064 7.5858 5.71934 4.95912C5.99325 4.67912 7.94323 2.92579 8.19106 3.18579C9.54106 7.59247 10.0171 8.7858 10.1345 8.75247C10.3758 8.6858 10.3106 2.96579 10.5715 1.77912C10.6563 1.39912 10.8324 1.20579 10.8911 1.14579C11.0932 0.939119 11.3737 0.819119 11.7258 0.779119C13.0106 0.632449 16.5063 0.619116 17.7845 0.779119C18.3845 0.852453 18.6911 1.31245 18.8411 1.87912C18.8737 2.69245 18.9128 3.91245 18.8802 5.40579C18.8345 7.6658 18.678 8.6858 18.8802 8.73913C19.0824 8.79247 19.6367 7.8658 21.2606 3.18579C22.0498 3.73912 25.7215 6.40579 26.6998 9.8858C26.9476 10.7725 27.2867 12.6458 27.3585 14.7325C27.3845 15.3658 27.378 15.8991 27.365 16.2591C27.3454 16.2858 27.3128 16.3191 27.2867 16.3525C27.2476 16.3925 27.2019 16.4325 27.1954 16.4325H2.02151V16.4391Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          fill="none"
        />

        <path
          d="M2.00199 16.4193L27.0846 16.3793C28.9563 16.206 29.3737 18.5393 27.6455 19.0193H1.85199C0.188945 18.8126 0.267206 16.3526 2.00199 16.4126V16.4193Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          fill="none"
        />
      </g>
    </g>

    <defs>
      <clipPath id="clip0_13727_5222">
        <rect width="30" height="20" fill="white" />
      </clipPath>
    </defs>
  </SvgIcon>
);
